import type { PathObject } from '../../types';

/**
 * class to extend the functionality of an array of PathObjects, while maintaining a current list of all the ids in all the PathObjects in the wrapped array.
 */
class PathList extends Array<PathObject> {
  private _ids: Set<string>;
  constructor(...items: PathObject[]) {
    super(...items);
    this._ids = new Set(items.flatMap(({ ids }) => (ids ? [...ids] : []))); // ids isn't supposed to be undefined, but it is when I run the unit tests...
  }
  /** A set containing all the ids in all the PathObjects in this PathList. */
  get ids() {
    return this._ids;
  }
  addPaths(paths: PathObject[]) {
    paths.forEach(path => {
      path.ids.forEach(id => this.ids.add(id));
      super.push(path);
    });
  }

  override push(...items: PathObject[]) {
    this.addPaths(items);
    return this.length;
  }
}
export { PathList };
